/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Pit3_DInputs */

const en_formatter_pit3_d = /** @type {(inputs: Formatter_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because numbers are normalized and duplicate keys collapse, formatted output is not a canonical form you can hash and compare against a signature produced elsewhere. Use a canonicalization scheme such as JCS if you need byte stable output across implementations.`)
};

const ko_formatter_pit3_d = /** @type {(inputs: Formatter_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숫자가 정규화되고 중복 키가 합쳐지므로, 포매팅된 출력은 다른 구현이 만든 서명과 비교해 해시할 수 있는 정규형이 아닙니다. 구현 간에 바이트 단위로 안정된 출력이 필요하면 JCS 같은 정규화 규격을 쓰세요.`)
};

const ja_formatter_pit3_d = /** @type {(inputs: Formatter_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値が正規化され重複キーがまとめられるため、整形後の出力は、別の実装が作った署名と比べてハッシュできる正規形ではありません。実装間でバイト単位に安定した出力が必要なら、JCS のような正規化仕様を使ってください。`)
};

/**
* | output |
* | --- |
* | "Because numbers are normalized and duplicate keys collapse, formatted output is not a canonical form you can hash and compare against a signature produced el..." |
*
* @param {Formatter_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_pit3_d = /** @type {((inputs?: Formatter_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_pit3_d(inputs)
	if (locale === "ko") return ko_formatter_pit3_d(inputs)
	return ja_formatter_pit3_d(inputs)
});